import axios from 'axios';
import AuthService from './AuthService';

let interceptorsRegistered = false;

const loginHashRoute = '#/login';

const isAuthenticationRequest = (url = '') =>
  String(url).toLowerCase().includes('authenticate');

const redirectToLogin = () => {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.location.hash !== loginHashRoute) {
    window.location.hash = loginHashRoute;
  }
};

const registerAxiosInterceptors = () => {
  if (interceptorsRegistered) {
    return;
  }

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const statusCode = error?.response?.status;
      const requestUrl = error?.config?.url;

      if (statusCode === 401 && !isAuthenticationRequest(requestUrl)) {
        AuthService.logout();
        redirectToLogin();

        // Prevent expired sessions from surfacing as uncaught runtime errors
        // while the router navigates back to the login screen.
        return new Promise(() => {});
      }

      return Promise.reject(error);
    }
  );

  interceptorsRegistered = true;
};

export default registerAxiosInterceptors;
